import React, { useEffect, useState } from 'react'
import OtherConfigCommonFilter from './OtherConfigCommonFilter'
import { Box, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material'
import { getBookingTypeOpt, getHeaderColumnDefs, getOtherCargoCol2Defs, getCreditLimitTypeOpt } from '../../BrnchMasterConstant'
import DropDownOA from '../../../../../common/dropDownOA'
import { Item } from '../../../../../common/snippets'
import * as sx from '../../../../../common/stylesInline/report_daily_branch'
import { getFloat, navigation3 } from '../../../../../common/helper'
import LineinputV2 from '../../../../../common/lineinputV2'
import OtherConfigCommonBottom from './OtherConfigCommonBottom'
import { callAddFontRobotoBold } from '../../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { useTranslation } from '../../../../../../i18n/I18nProvider'

const OtherCargoCreditLimit = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const bookingTypeOpt = getBookingTypeOpt(translations)
    const headerColumnDefs = getHeaderColumnDefs(translations)
    const otherCargoCol2Defs = getOtherCargoCol2Defs(translations)
    const CreditLimitTypeOpt = getCreditLimitTypeOpt(translations)

  const { tabInfo } = props
  const { resetFlag, setResetFlag, resetAllValueBrnhMaster, getBranchCargoData,
    brnhOtherCargoValue, setBrnchOtherCargoValue, onSave, confModal, setConfModal, isDisableBtn, setIsDisableBtn,
    handleBack, showBottom, setShowBottom, headerData, getPdfData, loginData } = tabInfo
  const [searchResult, setSearchResult] = useState(false)
  const [tableData, setTableData] = useState([])
  useEffect(() => {
    const fetchTableData = async () => {
      let data = await getPdfData()
      data = data.map((item, index) => (
        {
          ...item,
          SN: index + 1,
          isCreditLimit: item?.IsCargoCreditLimit === 1 ? (bum.yes || 'Yes') : (bum.no || 'No'),
          // creditLimitVal:item?.CreditLimit?.['id']===1?'Limited':item?.CreditLimit?.['id']===2?'Unlimited':'',
          creditLimitVal: item.CargoCreditLimit > 0 ? 'Limited' : 'Unlimited',
          stopBkngType: (item.CreditLimitPayType?.['id'] === 1 || item.CreditLimitPayType === 1) ? 'Paid Only' : (item.CreditLimitPayType?.['id'] === 2 || item.CreditLimitPayType === 2) ? 'Paid & ToPay' : ''
        }))
      setTableData(data);
    };

    fetchTableData();
  }, [])
  const handleBrnhCargoValue = (value, field, prevValue) => {
    if (value != prevValue) {
      if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
        setConfModal((prev) => ({
          ...prev,
          branchOtherConfig: true
        }))
      }
      setBrnchOtherCargoValue((prev) => ({
        ...prev, [field]: value
      }))
    }
  }
  const handleBrnhAmtDropDown = (value, field, field1, field2) => {
    if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
      setConfModal((prev) => ({
        ...prev,
        branchOtherConfig: true
      }))
    }
    setBrnchOtherCargoValue((prev) => ({
      ...prev, [field]: value, [field1]: 0, [field2]: 0
    }))
  }
  const handlecreditlimit = (value, field) => {
    setBrnchOtherCargoValue({ ...brnhOtherCargoValue, [field]: value, 'CargoCreditLimit': 0 })
  }
  const handleBookingType = (val) => {
    if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
      setConfModal((prev) => ({
        ...prev,
        branchOtherConfig: true
      }))
    }
    setBrnchOtherCargoValue((prev) => ({
      ...prev,
      CreditLimitPayType: val,
    }))
  }
  const handlePaidAndToPay = (value) => {
    if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
      setConfModal((prev) => ({
        ...prev,
        branchOtherConfig: true
      }))
    }
    if (brnhOtherCargoValue?.CreditLimitPayType?.id == 1) {
      setBrnchOtherCargoValue((prev) => ({
        ...prev,
        PaidCreditLimit: value,
        TopayCreditLimit: 0
      }))
    } else if (brnhOtherCargoValue?.CreditLimitPayType?.id == 2) {
      setBrnchOtherCargoValue((prev) => ({
        ...prev,
        PaidCreditLimit: value,
        TopayCreditLimit: value
      }))
    }
  }
  const printClick = async (isSave = false) => {

    let pdfData = await getPdfData()
    pdfData = pdfData.map((item, index) => (
      {
        ...item,
        SN: index + 1,
        isCreditLimit: item?.IsCargoCreditLimit === 1 ? (bum.yes || 'Yes') : (bum.no || 'No'),
        // creditLimitVal:item?.CreditLimit?.['id']===1?'Limited':item?.CreditLimit?.['id']===2?'Unlimited':'',
        creditLimitVal: item.CargoCreditLimit > 0 ? 'Limited' : 'Unlimited',
        stopBkngType: (item.CreditLimitPayType?.['id'] === 1 || item.CreditLimitPayType === 1) ? 'Paid Only' : (item.CreditLimitPayType?.['id'] === 2 || item.CreditLimitPayType === 2) ? 'Paid & ToPay' : ''
      }))
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = headerColumnDefs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfCols = otherCargoCol2Defs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })

    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(16)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, "right")
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
    }
    doc.setProperties({
      title: `Credit Limit.pdf`,
      subject: 'Cargo Other Config',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Cargo Other Config',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 0 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: headerData,
      columnStyles: {
        0: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 16,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },

    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: pdfCols,
      body: pdfData,
      columnStyles: {
        0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 37, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        5: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        6: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        7: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        8: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        9: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },

      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 14,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo Other Config | Credit Limit', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData?.strBranchName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(`Print: Cargo Other Config | Credit Limit`, data.settings.margin.left, 140)
        doc.text(`Branch: ${loginData?.strBranchName}`, doc.internal.pageSize.width - data.settings.margin.left, 140, "right")
        doc.text(`Date & Time: ${moment(new Date()).format('DD-MMM-YYYY, ddd, HH:mm')} `, data.settings.margin.left, 160)
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      }
    })
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      const pdfData = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfData);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = 'Cargo Config-Credit Limit.pdf';
      link.click();
    } else {
      // Trigger download
      const pdfBlob = new Blob([doc.output('blob')], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      // Open the PDF in a new tab
      window.open(pdfUrl);
    }
  }
  const InsideRowContentForExcel = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top', fontSize: '16px' }}>
          <>
            <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
              {index + 1}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BranchCode}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BranchName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.CityName}
            </TableCell>

            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.StateName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.isCreditLimit}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.creditLimitVal}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.CargoCreditLimit}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.stopBkngType}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.PaidCreditLimit}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  return (
    !searchResult ?
      <>
        <OtherConfigCommonFilter
          resetAllValueBrnhMaster={() => {
            resetAllValueBrnhMaster();
            setResetFlag(!resetFlag)
          }} getData={getBranchCargoData} nextId='other-CL' setShowBottom={setShowBottom} />
        <Divider />
        {showBottom && <> <Grid container sx={{ padding: '6px 8px' }}>
          <Grid item md={2}>
            <Item >
              <FormControlLabel
                value="end"
                control={<Checkbox checked={brnhOtherCargoValue?.IsCargoCreditLimit === 1} id='other-CL' />}
                onKeyDown={(e) => {
                  navigation3(e, brnhOtherCargoValue?.IsCargoCreditLimit === 1 ? "credit_limit1" : 'Cancel_LR', 'cargo_book_gst', () => { })
                }}
                label={
                  <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                    {bum.creditLimit || 'Credit Limit'}
                  </Typography>
                }
                onChange={(event) => {
                  handleBrnhCargoValue(event.target.checked ? 1 : 0, 'IsCargoCreditLimit', brnhOtherCargoValue?.IsCargoCreditLimit)
                }}
                labelPlacement="end"
              />
            </Item>
          </Grid>
          <Grid item md={3}>
            <Item className={'input--wrapper btmSpaceNotRequired'}>
              <DropDownOA
                label={bum.creditLimit || 'Credit Limit'}
                id='credit_limit1'
                data={CreditLimitTypeOpt || []}
                defaultvalue={brnhOtherCargoValue?.CreditLimit?.name || brnhOtherCargoValue?.CreditLimit}
                value={brnhOtherCargoValue?.CreditLimit?.name || brnhOtherCargoValue?.CreditLimit}
                disabled={brnhOtherCargoValue?.IsCargoCreditLimit === 0}
                onSelect={(val) => handlecreditlimit(val, "CreditLimit")}
                onReset={() => handlecreditlimit('', "CreditLimit")}
                dataKey={'name'}
                idKey={'id'}
                nextId={'CL_amount'}
                prevId={'other-CL'}
                resetFlag={resetFlag}
                portal={true}
              />
            </Item>
          </Grid>
          <Grid item md={3}>
            <Item className={'input--wrapper btmSpaceNotRequired'}>
              <LineinputV2
                label={bum.amount || 'Amount'}
                id='CL_amount'
                icon={'crossIcon'}
                filter={getFloat}
                disabled={brnhOtherCargoValue?.CreditLimit?.id === 2 || brnhOtherCargoValue?.IsCargoCreditLimit === 0}
                value={brnhOtherCargoValue?.CargoCreditLimit}
                maxLength={7}
                onKeyDown={(e) => {
                  navigation3(e, "paid", 'credit_limit1', () => { })
                }}
                onBlur={(event) => {
                  handleBrnhCargoValue(event.target.value, 'CargoCreditLimit', brnhOtherCargoValue?.CargoCreditLimit)
                }}
                resetCallback={() => {
                  handleBrnhCargoValue(0, 'CargoCreditLimit', ' ')
                }}
              />
            </Item>
          </Grid>
          <Grid item md={2}>
            <Item className={'input--wrapper btmSpaceNotRequired'}>
              <DropDownOA
                label={bum.stopBookingType || 'Stop Booking Type'}
                id='paid'
                data={bookingTypeOpt || []}
                defaultvalue={brnhOtherCargoValue?.CreditLimitPayType?.name || brnhOtherCargoValue?.CreditLimitPayType}
                value={brnhOtherCargoValue?.CreditLimitPayType?.name || brnhOtherCargoValue?.CreditLimitPayType}
                disabled={brnhOtherCargoValue?.IsCargoCreditLimit === 0}
                onSelect={(val) => handleBookingType(val)}
                onReset={() => { setBrnchOtherCargoValue((prev) => ({ ...prev, CreditLimitPayType: '', PaidCreditLimit: 0, TopayCreditLimit: 0 })) }}
                dataKey={'name'}
                idKey={'id'}
                nextId={'to_pay'}
                prevId={brnhOtherCargoValue?.CreditLimit?.id === 2 || brnhOtherCargoValue?.IsCargoCreditLimit === 0 ? 'credit_limit1' : 'CL_amount'}
                resetFlag={resetFlag}
                portal={true}
              />
            </Item>
          </Grid>
          <Grid item md={2}>
            <Item className={'input--wrapper btmSpaceNotRequired'}>
              <LineinputV2
                label={bum.inTopayLimit || 'In-ToPay Limit'}
                id='to_pay'
                value={brnhOtherCargoValue?.PaidCreditLimit}
                icon={'crossIcon'}
                filter={getFloat}
                onKeyDown={(e) => {
                  navigation3(e, "cancelBtn", 'paid', () => { })
                }}
                maxLength={5}
                onBlur={(event) => {
                  handlePaidAndToPay(Number(event.target.value))
                }}
                resetCallback={() => {
                  handlePaidAndToPay(0)
                }}
                disabled={brnhOtherCargoValue?.IsCargoCreditLimit === 0 || brnhOtherCargoValue?.CreditLimitPayType === ''}
              />
            </Item>
          </Grid>
        </Grid>
          <Divider />
          <OtherConfigCommonBottom onSave={onSave} handleBack={handleBack} printClick={printClick} setSearchResult={setSearchResult} fileName={'creditLimit'} />
        </>}
        <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)' }}>
          {/* ---------------Table For Excel--------------- */}
          <Table id="table-to-xls1" className="table1 table-Report" size="small" aria-label="a dense table" style={{ display: 'none' }}>
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              {/* -------TableHeader--------- */}
              <TableRow style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                <TableCell className="reportTD" colSpan={4}>
                  {bum.reportForCreditLimit || 'Report For: Credit Limit'}
                </TableCell>
                <TableCell className="reportTD" colSpan={4}>
                  {bum.companyNameMavenTechServicesPvtLtd || 'Company Name : _Maven Tech Services Pvt. Ltd.'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={12}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {headerColumnDefs?.map((item, i) => (
                  <TableCell
                    className="ReportItemHead"
                    style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                    colSpan={2}
                    key={i}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
              {headerData?.map((item, i) => (
                <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.CompanyName}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.State}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.City}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.Branch}</span>
                  </TableCell>
                </TableRow>))}
              <TableRow>
                <TableCell colSpan={12}></TableCell>
              </TableRow>
              <TableRow style={{ fontSize: '16px', verticalAlign: 'top' }}>
                {otherCargoCol2Defs?.map((item, i) => (
                  <TableCell
                    className="ReportItemHead"
                    style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                    colSpan={1}
                    key={i}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={11}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                        }}
                      >
                        <span>{cs.noResultsFound || 'No results found. Please refine your search parameters and search again.'}</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '500',
                  marginLeft: '5px',
                }}
              >
                {tableData?.map((item, index) => (
                  <InsideRowContentForExcel item={item} index={index} key={index} />
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </> :
      <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
        <object
          id="creditLimitOutput"
          type="application/pdf"
          width="100%"
          height="200"
          title={bum.mtlplCargoSystemCargoConfigCreditLimit || 'MTLPL -Cargo System - Cargo Config - Credit Limit'}
          aria-label={bum.mtlplCargoSystemCargoConfigCreditLimit2 || 'MTLPL -Cargo System - Cargo Config- Credit Limit'}
        ></object>
      </Box>
  )
}

export default OtherCargoCreditLimit
